import "@fortawesome/fontawesome-free/css/all.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import fa from "@/i18n/fa";
import en from "@/i18n/en";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { fa, en },
    current: "en"
  },
  rtl: false,
  icons: {
    iconfont: ["fa"]
  }
});
